import React, {Component} from 'react'
import TextWithElementsShape from "../types/TextWithElementsShape";
import trans from "trans";
import RenderText from "../render-text";
import {GradientDefs} from "shape-edit/forms/fields";
import { getBackgroundObjectByShape } from 'template-edit/components/helper';
import { Size } from 'app/types/model-types';
import { EditModeType } from 'app/types/app-types';

interface Props {
    data: TextWithElementsShape
    activeShapeId: string
    editMode: EditModeType
}

interface State {
    newSize: Size
}

class TextWithElementsSvg extends Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            newSize: null,
        }
    }

    setRealSize = (newSize: Size) => {
        this.setState({newSize: newSize})
    }

    render() {
        const shapeObject : TextWithElementsShape = this.props.data
        const scale = shapeObject.scale && shapeObject.scale !== 0 ? shapeObject.scale : 1
        const width = shapeObject.width ? shapeObject.width : 0
        const height = shapeObject.height ? shapeObject.height : 0
        const isShadow = shapeObject.shadow_color && shapeObject.shadow_sigma
        const backgroundObject = getBackgroundObjectByShape(shapeObject, this.state.newSize)

        const h = Math.round(shapeObject.text_fontsize / scale)

        return (
            <g className={`draggable ${shapeObject.text_content_replaced ? 'dynamic' : ''}`}>
                {isShadow &&
                <filter id={`shadow-${shapeObject.index}`} width="200%" height="200%" y="-50%" x="-50%">
                    <feDropShadow
                        dx={shapeObject.shadow_xoffset}
                        dy={shapeObject.shadow_yoffset}
                        stdDeviation={shapeObject.shadow_sigma}
                        floodColor={shapeObject.shadow_color}
                        floodOpacity={1-shapeObject.shadow_opacity/100}
                    />
                </filter>
                }

                {shapeObject.gradient_id && shapeObject.gradient &&
                <GradientDefs gradient={shapeObject.gradient} idx={shapeObject.gradient_id} />
                }

                {backgroundObject}

                <RenderText
                    shape={shapeObject}
                    fontSize={h}
                    width={width}
                    h={height}
                    setRealSize={this.setRealSize}
                    offsetY={0}
                    activeShapeId={this.props.activeShapeId}
                    editMode={this.props.editMode}
                />
            </g>
        )
    }
}

export default TextWithElementsSvg

